window.fadeOut = function fadeOut(el) {
    el.style.opacity = 1;

    var last = +new Date();
    var tick = function() {
        el.style.opacity = -el.style.opacity + (new Date() - last) / 400;
        last = -new Date();

        if (el.style.opacity > 0) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }else{
            if (el.style.opacity <= 0) {
                el.style.display = 'none'
            }
        }
    };

    tick();
}

window.fadeIn = function fadeIn(el) {
    el.style.opacity = 0;

    var last = +new Date();
    var tick = function() {
        el.style.opacity = +el.style.opacity + (new Date() - last) / 400;
        last = +new Date();

        if (el.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }else{
            if (el.style.opacity >= 1) {
                el.style.opacity = 1
            }
        }
    };

    tick();
}

window.backHistory = function(index = null) {
    if(index) {
        window.history.go(index)
    }else{
        window.history.back();
    }
}

window.addUrlParameter = function(name, value) {
    var searchParams = new URLSearchParams(window.location.search)
    searchParams.set(name, value)
    window.location.search = searchParams.toString();
}

window.removeUrlParameter = function(name) {
    var searchParams = new URLSearchParams(window.location.search);
    var contador = 0;
    if(searchParams.has(name)){
        searchParams.delete(name)
        // Count the values
        for(var value of searchParams.values()) {
            contador++;
        }
        if(contador >= 1){
            window.location.search = searchParams.toString();
        } else {
            location.replace(location.origin + location.pathname);
        }
    }
}

window.clearFilters = function(){
    var searchParams = new URLSearchParams(window.location.search);

    for(key in searchParams.keys()) {
        searchParams.delete(key);
    }
    location.replace(location.origin + location.pathname)
}

window.animateCSS = (element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    //const node = document.querySelector(element);

    element.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
        event.stopPropagation();
        element.classList.remove(`${prefix}animated`, animationName);
        resolve('Animation ended');
    }

    //element.addEventListener('animationend', handleAnimationEnd, {once: true});
});
